import React from 'react';

export default ({calculatePositionOfStickyHeaders, config, team, index}) => (
  <td
    className={`text-center ${index === 0 ? 'first-cell' : ''}`}
    style={calculatePositionOfStickyHeaders(config)}
  >
    {team.name}
  </td>
);
